import { render, staticRenderFns } from "./GoodAt.vue?vue&type=template&id=020738db&scoped=true&"
import script from "./GoodAt.vue?vue&type=script&lang=js&"
export * from "./GoodAt.vue?vue&type=script&lang=js&"
import style0 from "./GoodAt.vue?vue&type=style&index=0&id=020738db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020738db",
  null
  
)

export default component.exports